module.exports = __webpack_public_path__ + "img/right-arrow.4629bd3f.svg";